import { ContentfulLivePreview } from "@contentful/live-preview";

export const getContentfulPreviewPropsFn = (contentfulId) => (fieldId) =>
  fieldId && contentfulId
    ? ContentfulLivePreview.getProps({
        entryId: contentfulId,
        fieldId,
      })
    : {};
